// extracted by mini-css-extract-plugin
export default {"timestamp":"MessageTimestamp_timestamp__rE28L","timestamp-outgoing":"MessageTimestamp_timestamp-outgoing__MTdoj"};